import * as React from 'react';

import { Slot } from '@radix-ui/react-slot';
import { ZodError } from 'zod';

import { cn } from 'src/utils/shadcn';

export interface TextareaProps extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'value'> {
    error?: ZodError;
    value?: string | number | readonly string[];
    asChild?: boolean;
    index?: number;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className, error, index, asChild, ...props }, ref) => {
        const isError = index != null && Array.isArray(error) ? !!error[index] : !!error;

        const TextareaComp = asChild ? (
            <Slot className={className} ref={ref} {...props} />
        ) : (
            <textarea
                className={cn(
                    'focus-visible:ring-primary-600 flex h-24 w-full rounded-md border border-gray-200 bg-white px-4 py-2 shadow-xs ring-offset-white transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-400 hover:border-gray-300 hover:shadow-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-gray-100 disabled:opacity-50 disabled:shadow-none dark:border-gray-800 dark:bg-gray-950 dark:ring-offset-gray-950 dark:placeholder:text-gray-400 dark:focus-visible:ring-gray-300',
                    isError &&
                        'border-red-300 hover:border-red-500 focus-visible:border-red-500 focus-visible:ring-red-200 dark:border-red-900 dark:hover:border-red-900',
                    className,
                )}
                ref={ref}
                {...props}
            />
        );

        return TextareaComp;
    },
);
Textarea.displayName = 'Textarea';

export { Textarea };
